"use client";

import { useCallback } from "react";
import { useConfirm } from "@/ui/components/confirm-gate";

export function useGateCartAction() {
	const { requestConfirm } = useConfirm();

	return useCallback(
		(action: () => void) => {
			requestConfirm(action);
		},
		[requestConfirm],
	);
}
